(() => {
  const controllers = new Map();
  const menuSelector = '.drawer-menu__main > .drawer-menu__primary-links';

  function mount(drawer) {
    if (controllers.has(drawer)) return;
    const template = document.getElementById('thl-menu-offer-template');
    if (!template) return;
    const card = template.content.firstElementChild.cloneNode(true);
    let signupTimer = 0;
    let disposed = false;
    const menu = drawer.querySelector(menuSelector);
    if (!menu) return;
    const bottom = drawer.querySelector('[data-thl-menu-bottom]');
    if (bottom) bottom.prepend(card);
    else menu.after(card);

    const countryTrigger = drawer.querySelector('[data-thl-country-trigger]');
    function openCountry() {
      drawer.querySelector('[data-thl-currency-parent]')?.click();
      const list = drawer.querySelector('.drawer-menu__main');
      if (list) list.scrollTop = 0;
    }
    countryTrigger?.addEventListener('click', openCountry);

    function openSignup(event) {
      if (!event.target.closest('.thl-menu-offer__button') || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById('thl-welcome-signup');
      if (!target) return;
      event.preventDefault();
      drawer.querySelector('[data-drawer-close]')?.click();
      const group = target.closest('.footer__group');
      const content = target.closest('.footer__group-content');
      if (content && getComputedStyle(content).display === 'none') group?.querySelector('[data-header]')?.click();
      clearTimeout(signupTimer);
      signupTimer = setTimeout(() => {
        if (disposed || !target.isConnected) return;
        target.scrollIntoView({ block: 'center', behavior: 'auto' });
        const focusTarget = target.querySelector('input[type="email"]') || target;
        focusTarget.focus({ preventScroll: true });
      }, 450);
    }

    card.addEventListener('click', openSignup);
    controllers.set(drawer, () => {
      disposed = true;
      clearTimeout(signupTimer);
      countryTrigger?.removeEventListener('click', openCountry);
      card.removeEventListener('click', openSignup);
      card.remove();
    });
  }

  function mountAll() {
    for (const [drawer, cleanup] of controllers) {
      if (!drawer.isConnected) { cleanup(); controllers.delete(drawer); }
    }
    document.querySelectorAll('[data-drawer-menu]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    for (const [drawer, cleanup] of controllers) {
      if (event.target.contains(drawer)) { cleanup(); controllers.delete(drawer); }
    }
  });
})();
